import * as UI from "@accurx/design";
import { Pill } from "@accurx/inbox-design-library";
import styled from "styled-components";

export const StyledUnreadLabelText = styled(Pill.Text)`
    color: ${UI.Tokens.COLOURS.greyscale.zinc};
`;
